import React, { useEffect } from "react";
import HomeBanner from "../components/home/HomeBanner";
import HomeAbout from "../components/home/HomeAbout";
import HomeChoose from "../components/home/HomeChoose";
import HomeServices from "../components/home/HomeServices";
import HomeStats from "../components/home/HomeStats";
import HomeSteps from "../components/home/HomeSteps";
import HomeContact from "../components/home/HomeContact";
import HomeReviews from "../components/home/HomeReviews";
import HomeBlogs from "../components/home/HomeBlogs";
import HomeFaqs from "../components/home/HomeFaqs";
import { useLenis } from "lenis/react";

const HomePage = () => {
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, {
        duration: 1.2,
      });
    }
  }, [lenis]);
  return (
    <>
      <HomeBanner />
      <HomeAbout />
      <HomeChoose />
      <HomeServices />
      <HomeStats />
      <HomeSteps />
      <HomeContact />
      <HomeReviews />
      <HomeBlogs />
      <HomeFaqs />
    </>
  );
};

export default HomePage;
